import { useQuery } from '@tanstack/react-query';
import { AgentsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';
import { ADMIN_QUERY_KEYS } from '@/features/admin/api/query-keys';

// Every reader of `tools.agents` must go through here: the key is shared, so a second
// queryFn with other params would serve its data to the readers of this one.
export const useAdminAgents = () => {
  return useQuery({
    queryKey: ADMIN_QUERY_KEYS.tools.agents,
    queryFn: async () => {
      const response = await AgentsService.getAllAgents({
        client: inferenceHttp,
        query: { includeNonVisibleAgents: false, showAll: true },
      });
      return response.data ?? [];
    },
  });
};
